import { notification } from 'antd';
/**
 * Notification component
 * @param {*} message -
 * @param {*} description -
 * @param {*} type -
 * @param {*} direction -
 */
const OpenNotification = (message, description, type, direction='bottomRight') => {
  notification[type]({
    message: message,
    description: description,
    placement: direction,
  });
};

export default OpenNotification;